/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";

/**
 *
 * @export
 * @interface ExtractionUpdateRequest
 */
export interface ExtractionUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof ExtractionUpdateRequest
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof ExtractionUpdateRequest
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExtractionUpdateRequest
   */
  format?: string;
  /**
   *
   * @type {boolean}
   * @memberof ExtractionUpdateRequest
   */
  processing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ExtractionUpdateRequest
   */
  queued?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ExtractionUpdateRequest
   */
  cancelled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ExtractionUpdateRequest
   */
  errored?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ExtractionUpdateRequest
   */
  archived?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ExtractionUpdateRequest
   */
  completed?: boolean;
  /**
   *
   * @type {string}
   * @memberof ExtractionUpdateRequest
   */
  s3Bucket?: string;
  /**
   *
   * @type {string}
   * @memberof ExtractionUpdateRequest
   */
  s3Key?: string;
  /**
   *
   * @type {number}
   * @memberof ExtractionUpdateRequest
   */
  size?: number;
  /**
   *
   * @type {number}
   * @memberof ExtractionUpdateRequest
   */
  progress?: number;
  /**
   *
   * @type {object}
   * @memberof ExtractionUpdateRequest
   */
  error?: object;
  /**
   *
   * @type {string}
   * @memberof ExtractionUpdateRequest
   */
  note?: string;
  /**
   *
   * @type {object}
   * @memberof ExtractionUpdateRequest
   */
  context?: object;
  /**
   *
   * @type {Date}
   * @memberof ExtractionUpdateRequest
   */
  deletedAt?: Date;
}

export function ExtractionUpdateRequestFromJSON(
  json: any
): ExtractionUpdateRequest {
  return ExtractionUpdateRequestFromJSONTyped(json, false);
}

export function ExtractionUpdateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExtractionUpdateRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    status: !exists(json, "status") ? undefined : json["status"],
    name: !exists(json, "name") ? undefined : json["name"],
    format: !exists(json, "format") ? undefined : json["format"],
    processing: !exists(json, "processing") ? undefined : json["processing"],
    queued: !exists(json, "queued") ? undefined : json["queued"],
    cancelled: !exists(json, "cancelled") ? undefined : json["cancelled"],
    errored: !exists(json, "errored") ? undefined : json["errored"],
    archived: !exists(json, "archived") ? undefined : json["archived"],
    completed: !exists(json, "completed") ? undefined : json["completed"],
    s3Bucket: !exists(json, "s3_bucket") ? undefined : json["s3_bucket"],
    s3Key: !exists(json, "s3_key") ? undefined : json["s3_key"],
    size: !exists(json, "size") ? undefined : json["size"],
    progress: !exists(json, "progress") ? undefined : json["progress"],
    error: !exists(json, "error") ? undefined : json["error"],
    note: !exists(json, "note") ? undefined : json["note"],
    context: !exists(json, "context") ? undefined : json["context"],
    deletedAt: !exists(json, "deleted_at")
      ? undefined
      : new Date(json["deleted_at"]),
  };
}

export function ExtractionUpdateRequestToJSON(
  value?: ExtractionUpdateRequest | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    status: value.status,
    name: value.name,
    format: value.format,
    processing: value.processing,
    queued: value.queued,
    cancelled: value.cancelled,
    errored: value.errored,
    archived: value.archived,
    completed: value.completed,
    s3_bucket: value.s3Bucket,
    s3_key: value.s3Key,
    size: value.size,
    progress: value.progress,
    error: value.error,
    note: value.note,
    context: value.context,
    deleted_at:
      value.deletedAt === undefined ? undefined : value.deletedAt.toISOString(),
  };
}
